import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { FxmsData } from "../../datas/FxData";
import { DateUtil } from "../../datas/DateUtil";
import { AttrListEdit } from "../../datas/OpClass";
import { FxmsEvent } from "../../actions/FxEvent";
import { FxDashEditInfo } from "../FxDashBoard";

HighchartsMore(Highcharts);

class High extends Component {

  constructor(props) {
    super(props);
    this.state = {
      title:"",
      psName:"",
      psUnit:"",
      datas:[]
    }
  }


  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.psItem){
      this.setState({
        title:nextProps.title,psName:nextProps.psItem.psName,psUnit:nextProps.psItem.psUnit,datas:nextProps.datas
      })
    }
  }

  render() {
    // const { title, psItem, datas } = this.props;
    // const psName = psItem ? psItem.psName : "";
    // const psUnit = psItem ? psItem.psUnit : "";

    const options = {
      chart: {
        zoomType: "x",
        backgroundColor: "rgba(255,255,255, 0.1)",
      },
      title: {
        text: this.state.title,
        style: { color: "white" },
      },
      // subtitle: {
      //   text: document.ontouchstart === undefined ? 'Click and drag in the plot area to zoom in'
      //     : 'Pinch the chart to zoom in'
      // },
      xAxis: {
        type: "datetime",
      },
      yAxis: {
        title: {
          text: this.state.psUnit,
          style: { color: "white" },
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 255,
              y1: 255,
              x2: 255,
              y2: 255,
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [
                1,
                Highcharts.color(Highcharts.getOptions().colors[0])
                  .setOpacity(0)
                  .get("rgba"),
              ],
            ],
          },
          marker: {
            radius: 2,
          },
          lineWidth: 2,
          color: 'yellow',
          states: {
            hover: {
              lineWidth: 1,
            },
          },
          threshold: null,
        },
      },

      series: [
        {
          type: "area",
          name: this.state.psName,
          data: this.state.datas,
        },
      ],
    };
    return (
      <>
        <HighchartsReact
          containerProps={{ style: { height: "100%" } }}
          highcharts={Highcharts}
          options={options}
        />
      </>
    );
  }
}

/**
 * 줌라인 챠트 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export function FxLineZoomChartConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect(10, "moNo", "관리대상", 300, "mo", { moClass: "SENSOR", });
  setList.makeAttrSelect(20, "psId", "수집항목", 300, "psItem", { moClass: "SENSOR", });
  setList.makeAttrButton(30, "cmdApplyDb", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;
}


/**
 * 줌라인 챠트
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export const FxLineZoomChart = (props) => {
  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [title, setTitle] = React.useState("noknown");
  const [psItem, setPsItem] = React.useState(null);
  const [mo, setMo] = React.useState({});
  const [datas, setDatas] = React.useState([]);
  const [intervalId, setIntervalId] = React.useState(null);
  const psDataCd = "MIN5";

  useEffect(() => {

    console.log("*** FxLineZoomChart *****************", fxUiGrpItem);

    onFxmsEvent(fxUiGrpItem.attrObj);

    const id = setInterval(showDatas, 10000);
    setIntervalId(id);


    return () => {
      if (intervalId != null) {
        clearInterval(intervalId);
      }
      FxmsEvent.removeEventListener(id);
    };

  }, []);

  async function showDatas() {
    if (mo.moNo === undefined || psItem === null) {
      return;
    }

    setTitle(mo.moName + "(" + psItem.psName + ")");

    const res = await FxmsData.GET("fxmsPs/value", {
      moNo: mo.moNo,
      psId: psItem.psId,
      psDataCd: psDataCd,
      psStatFuncList: "SUM,AVG",
      startPsDate: DateUtil.getDtm(new Date().getTime() - 86400000 * 1),
      endPsDate: DateUtil.getDtm(),
    });
    console.log("*** FxLineZoomChart *** result = ", res);
    if (res) {
      let result = res.data.result;
      if (result) {
        for (let i = 0; i < result[0].valueList.length; i++) {
          result[0].valueList[i][0] = DateUtil.makeDate(
            result[0].valueList[i][0]
          ).getTime();
        }
        setDatas(result[0].valueList);
      } else {
        setTitle(mo.moName + " :: " + psItem.psName + " 데이터 조회 오류!!");
      }
    }
  }

  useEffect(() => {

    showDatas();

  }, [mo, psItem]);

  // 다른 컴포넌에서 보낸 이벤트를 받는 함수
  async function onFxmsEvent(obj) {
    // console.log("FxmsEvent ... ", obj);

    if (obj && obj.moNo) {
      const mo = await FxmsData.getMo(obj.moNo);
      setMo(mo);
      console.log("*** FxLineZoomChart *** mo = ", mo);
    }

    if (obj && obj.psId) {
      const psItem = FxmsData.getPsItem(obj.psId);
      console.log("*** FxLineZoomChart *** psItem = ", psItem);
      if (psItem) {
        setPsItem(psItem);
      }
    }

  }

  // id가 설정되어 있으면 다른 컴포넌트에서 보낸 이벤트를 받기위해 등록한다.
  if (id) {
    FxmsEvent.addEventListener(id, onFxmsEvent);
  }

  if (editable) {
    return <FxDashEditInfo>줌이 가능한 라인챠트</FxDashEditInfo>;
  }

  return (
    <>
      <High title={title} mo={mo} psItem={psItem} datas={datas} />
    </>
  );
};

export const LineZoomChart = (props) => {
  const { selectedData } = props;
  const [title, setTitle] = React.useState("noknown");
  const [dataStat, setDataStat] = React.useState({});
  const [psItem, setPsItem] = React.useState(null);
  const [mo, setMo] = React.useState({});
  const [datas, setDatas] = React.useState([]);
  const psDataCd = "RAW";

  useEffect(() => {
    const item = selectedData.psItem ? selectedData.psItem : FxmsData.getPsItem(selectedData.psId);
    setPsItem(item);
    if (selectedData.mo) {
      setMo(selectedData.mo);
    } else {
      FxmsData.getMo(selectedData.moNo).then(function (mo) {
        setMo(mo);
        console.log("*** LineZoomChart *** mo item", mo, item, DateUtil.getDtm());
      });
    }
  }, []);

  useEffect(() => {
    showDatas();
  }, [mo, psItem]);

  function showDatas() {
    if (mo.moNo === undefined || psItem === null) {
      return;
    }

    setTitle(mo.moName + "(" + psItem.psName + ")");

    FxmsData.GET("fxmsPs/value", {
      moNo: mo.moNo,
      psId: psItem.psId,
      psDataCd: psDataCd,
      psStatFuncList: "SUM,AVG",
      startPsDate: DateUtil.getDtm(new Date().getTime() - 7200000 * 1),
      endPsDate: DateUtil.getDtm(),
    })
      .then(function (res) {
        console.log("*** LineZoomChart ***", res);
        let result = res.data.result;
        if (result) {
          for (let i = 0; i < result[0].valueList.length; i++) {
            result[0].valueList[i][0] = DateUtil.makeDate(
              result[0].valueList[i][0]
            ).getTime();
          }
          setDatas(result[0].valueList);
          console.log("*** LineZoomChart *** array", result[0].valueList);
          makeStat(result[0].valueList);
        } else {
          setTitle(mo.moName + " :: " + psItem.psName + " 데이터 조회 오류!!");
        }
      })
      .catch(function (error) {
        console.log("*** LineZoomChart ***", error);
      })
      .finally(function () { });
  }

  const makeStat = (datas) => {
    let minVal = Number.MAX_SAFE_INTEGER;
    let minTime = Number.MAX_SAFE_INTEGER;
    let maxVal = Number.MIN_SAFE_INTEGER;
    let maxTime = Number.MIN_SAFE_INTEGER;
    let avgVal = 0;

    for (let n of datas) {
      if (minVal > n[1]) minVal = n[1];
      if (minTime > n[0]) minTime = n[0];

      if (maxVal < n[1]) maxVal = n[1];
      if (maxTime < n[0]) maxTime = n[0];

      for (let i = 0; i < datas.length; i++) {
        avgVal += datas[i][1];
      }
      avgVal = avgVal / datas.length;
    }

    setDataStat({
      times: renderDateMstime(minTime) + " ~ " + renderDateMstime(maxTime),
      count: datas.length.toLocaleString(),
      minVal: minVal.toLocaleString(),
      maxVal: maxVal.toLocaleString(),
      avgVal: avgVal.toFixed(2),
    });
  };

  return (
    <>
      <High
        // title={title}
        mo={mo}
        psItem={psItem}
        datas={datas}
      />
      <br />
      <div style={{ display: "inline-block", padding: "7px 10px 0px 10px" }}>
        <div style={{ fontSize: 20 }}>
          조회기간 :{dataStat.times} / 총 건수 : {dataStat.count} / 최소값 :{" "}
          {dataStat.minVal} / 최대값 : {dataStat.maxVal} / 평균값 :{" "}
          {dataStat.avgVal}
        </div>
      </div>
    </>
  );
};

export function renderDateMstime(mstime) {
  function addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  const d = new Date();

  if (mstime != undefined) {
    d.setTime(mstime);
  }

  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let hour = d.getHours();
  let minutes = d.getMinutes();
  let seconds = d.getSeconds();

  return (
    year +
    "-" +
    addZero(month) +
    "-" +
    addZero(day) +
    " " +
    addZero(hour) +
    ":" +
    addZero(minutes) +
    ":" +
    addZero(seconds)
  );
}

export default FxLineZoomChart;
